import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';
import Validator from 'validatorjs';

import {
  Form, Button, Modal, Icon, Message, Select,
} from 'semantic-ui-react';
import flatRatesFromBatchesQuery from '../../graphql/flatRatesFromBatchesQuery';
import { FLAT_RATES_MILES } from '../../constants';

class NewFlatRateOfferForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: null,
      flatRateId: '',
      milesSelected: '',
      errors: {},
    };
  }

  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
      data: { flatRates },
    } = this.props;

    const {
      errors, flatRateId, milesSelected, price,
    } = this.state;

    const onChangeHandler = field => event => {
      this.setState({ [field]: event.target.value });
    };

    const onSelectHandler = field => (event, data) => {
      this.setState({ [field]: data.value });
    };

    const flatRateOptions = flatRates
      && flatRates.map(flatRate => ({
        text: flatRate.dealerNo,
        key: flatRate.id,
        value: parseInt(flatRate.id, 10),
      }));

    const validationRules = {
      flatRateId: 'required',
      milesSelected: 'required',
      price: 'required|numeric',
    };

    const submitForm = () => {
      const {
        price: statePrice,
        milesSelected: stateMilesSelected,
        flatRateId: stateFlatRateId,
      } = this.state;

      const {
        flatRateOfferBatch: { id },
      } = this.props;

      const validation = new Validator({
        price: statePrice,
        milesSelected: stateMilesSelected,
        flatRateId: stateFlatRateId,
      }, validationRules);
      validation.setAttributeNames({ flatRateId: 'dealer no' });

      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      onSubmitHandler({
        id: parseInt(id, 10),
        price: statePrice,
        milesSelected: stateMilesSelected,
        flatRateId: stateFlatRateId,
      });
      this.setState({ errors: {} });
      return true;
    };

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>Edit Dealshield 360 offer</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}
            <Form>
              <Form.Group widths='equal'>
                <Form.Field error={!isEmpty(errors.flatRateId)}>
                  <label htmlFor='flatRateId'>Dealer No</label>
                  <Select
                    id='flatRateId'
                    options={flatRateOptions}
                    closeOnBlur
                    value={flatRateId}
                    onChange={onSelectHandler('flatRateId')}
                  />
                  {errors.flatRateId && <span>{errors.flatRateId}</span>}
                </Form.Field>

                <Form.Field error={!isEmpty(errors.milesSelected)}>
                  <label htmlFor='milesSelected'>Miles:</label>
                  <Select
                    id='milesSelected'
                    options={FLAT_RATES_MILES}
                    closeOnBlur
                    value={milesSelected}
                    onChange={onSelectHandler('milesSelected')}
                  />
                  {errors.milesSelected && <span>{errors.milesSelected}</span>}
                </Form.Field>

                <Form.Field error={!isEmpty(errors.price)}>
                  <label htmlFor='price'>Price</label>
                  <Form.Input
                    id='price'
                    name='price'
                    placeholder='Price'
                    value={price || ''}
                    onChange={onChangeHandler('price')}
                  />
                  {errors.price && <span>{errors.price}</span>}
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}

          {!submitting && (
            <Button color='green' onClick={submitForm} inverted>
              <Icon name='checkmark' /> Update
            </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

NewFlatRateOfferForm.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  data: PropTypes.shape({
    flatRates: PropTypes.array,
  }),
  flatRateOfferBatch: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

const data = graphql(flatRatesFromBatchesQuery, {
  options: props => {
    const {
      flatRateOfferBatch: { id },
    } = props;
    return { variables: { flatRateOfferBatchId: parseInt(id, 10) } };
  },
});

export default compose(
  withRouter,
  data
)(NewFlatRateOfferForm);
